(() => {
  'use strict';
  const media = window.matchMedia('(max-width: 749px)');
  const labels = document.getElementById('pc-mobile-labels');
  const copy = labels ? JSON.parse(labels.textContent) : {};
  const wrappers = new Map();
  function fold(node, label, className = '') {
    if (!node || wrappers.has(node) || node.closest('.pc-mobile-disclosure')) return;
    const marker = document.createComment('pc-mobile-original-position');
    const details = document.createElement('details');
    details.className = 'pc-mobile-disclosure ' + className;
    const summary = document.createElement('summary');
    summary.textContent = label;
    const body = document.createElement('div');
    body.className = 'pc-mobile-disclosure__body';
    node.before(marker, details);
    details.append(summary, body);
    body.append(node);
    wrappers.set(node, { marker, details });
  }
  function apply() {
    if (!media.matches) {
      wrappers.forEach(({ marker, details }, node) => { marker.replaceWith(node); details.remove(); });
      wrappers.clear();
      return;
    }
    document.querySelectorAll('.pc-footer-main>.pc-footer-column:not(.pc-footer-contact)').forEach(node => {
      const heading = node.querySelector('h3');
      if (heading) fold(node, heading.textContent.trim());
    });
    const targets = [
      ['#pc-enterprise-2026 .atelier-card', copy.workshop || 'Notre torréfaction artisanale'],
      ['#pc-enterprise-2026 .colibri-section', copy.connected || 'Colibri : le suivi de votre machine'],
      ['#pc-enterprise-2026 #budget', copy.budget || 'Budget, tarifs et conditions'],
      ['#pc-enterprise-2026 .trust-section', copy.installation || 'Votre installation et notre accompagnement'],
      ['.pc-pro .moments-section', copy.moments || 'Les moments café en boulangerie'],
      ['.pc-pro .interactive-telemetry', copy.connected || 'Colibri : le suivi de votre machine'],
      ['.pc-pro .bakery-rse', copy.responsible || 'Le choix du café en grain'],
      ['.pc-pro .roles-strip', copy.roles || 'Qui s’occupe de quoi ?'],
      ['.pc-pro .objection-section', copy.questions || 'Vos questions sur les solutions'],
      ['.pc-pro .coffee-compact', copy.coffees || 'Découvrir les cafés proposés'],
      ['.pc-pro .launch-section', copy.installation || 'Votre installation et notre accompagnement'],
      ['.pc-team-story', copy.founders || 'Rencontrez les fondateurs de Patagonia Café'],
      ['.pc-pro .quick-compare', copy.compare || 'Comparer les trois solutions'],
      ['.pc-pro .telemetry-demo', copy.colibri || 'Voir Colibri en action'],
      ['.main-product:has(.pcf-strip) .product__description', copy.description || 'En savoir plus sur ce café'],
      ['.pc-espresso>.origin, .pc-fresh-origin', copy.origin || 'Origine et terroir'],
      ['.pc-espresso>.taste', copy.tasting || 'Les détails de dégustation'],
      ['.pc-espresso>.love', copy.profile || 'Ce qui fait son caractère']
    ];
    targets.forEach(([selector, label]) => document.querySelectorAll(selector).forEach(node => fold(node, label, node.closest('.pc-pro,#pc-enterprise-2026') ? 'pc-mobile-pro-fold' : '')));
    document.querySelectorAll('#pc-enterprise-2026 .service-item').forEach(node => {
      const heading = node.querySelector('h3') || node.querySelector('.service-title');
      if (heading) fold(node, heading.textContent.trim(), 'pc-mobile-service-fold');
    });
    document.querySelectorAll('.pcf-cards').forEach(group => {
      [...group.querySelectorAll('.pcf-card')].forEach(node => {
        const heading = node.querySelector('h2,h3');
        if (heading) fold(node, heading.textContent.trim());
      });
    });
    document.querySelectorAll('.pcm-back').forEach(node => fold(node, copy.details || 'Origine et arômes', 'pcm-special-detail'));
  }
  function openTarget(hash) {
    if (!hash) return null;
    let target;
    try { target = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (_) { return null; }
    if (!target) return null;
    let details = target.closest('.pc-mobile-disclosure');
    while (details) { details.open = true; details = details.parentElement.closest('.pc-mobile-disclosure'); }
    return target;
  }
  function revealHash() { const target = openTarget(location.hash); if (target) requestAnimationFrame(() => target.scrollIntoView({block: 'start'})); }
  document.addEventListener('click', event => {
    if (!media.matches || !(event.target instanceof Element)) return;
    const link = event.target.closest('a[href^="#"]');
    if (link) openTarget(link.getAttribute('href'));
  }, true);
  function init() { apply(); revealHash(); }
  media.addEventListener('change', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('hashchange', revealHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
